import { render, staticRenderFns } from "./bindResult.vue?vue&type=template&id=33d9c807&scoped=true&"
import script from "./bindResult.vue?vue&type=script&lang=js&"
export * from "./bindResult.vue?vue&type=script&lang=js&"
import style0 from "./bindResult.vue?vue&type=style&index=0&id=33d9c807&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d9c807",
  null
  
)

export default component.exports